export default {
  ShowTransfer: 'ShowTransfer',
  ShowCAReceipt: 'ShowCAReceipt',
  Save: 'Save',
  SaveAdd: 'SaveAdd',
  SaveClose: 'SaveClose',
  //Hoãn
  Postpone: 'Postpone',
  NextVoucher: 'NextVoucher',
  BackVoucher: 'BackVoucher',
  SaveView: 'SaveView',
  Ok: 'Ok',
  Delete: 'Delete',
  All: 'All',
  Follow: 'Follow',
  Unfollow: 'Unfollow',
  Active: 'Active',
  Unactive: 'Unactive',
  Edit: 'Edit',
  EditBatch: 'EditBatch',
  Duplicate: 'Duplicate',
  Add: 'Add',
  Approve: 'Approve',
  ApproveAgain: 'ApproveAgain',
  Reject: 'Reject',
  View: 'View',
  Posted: 'Posted',
  UnPosted: 'UnPosted',
  PostBatch: 'PostBatch',
  UnPostBatch: 'UnPostBatch',
  Estimate: 'Estimate',
  NextStep: 'NextStep',
  BackStep: 'BackStep',
  ViewAccount: 'ViewAccount',
  ViewQuantity: 'ViewQuantity',
  ViewAdvanceBalance: 'ViewAdvanceBalance',
  AddAutoBusiness: 'AddAutoBusiness',
  GenerateData: 'GenerateData',
  GenerateCaPaymentSalary: 'GenerateCaPaymentSalary',
  Refresh: 'Refresh',
  Copy: 'Copy',
  ShowWithDrawCash: 'ShowWithDrawCash',
  ShowWithDrawDeposit: 'ShowWithDrawDeposit',
  ShowWithDrawTransfer: 'ShowWithDrawTransfer',
  ShowWithDrawSalaryTransfer: 'ShowWithDrawSalaryTransfer',
  ShowBUTreasuryFundTransferSalary: 'ShowBUTreasuryFundTransferSalary',
  ShowBUTreasuryFundTransferInsurancePayment: 'ShowBUTreasuryFundTransferInsurancePayment',
  GLVoucherDetail: 'GLVoucherDetail',
  SaveParalell: 'SaveParalell',
  InsertRowGrid: 'InsertRowGrid',
  DeleteRowGrid: 'DeleteRowGrid',
  PostponeParalell: 'PostponeParalell',
  Cancel: 'Cancel',
  SettingAccount: 'SettingAccount',
  //Gửi phê duyệt
  SendApproval: 'SendApproval',
  SendApprovalAgain: 'SendApprovalAgain',
  Quit: 'Đóng',
  Print: 'Print',
  //Bảng kê
  BUVoucherListPlanned: 'BUVoucherListPlanned',
  BUVoucherListNotPlanned: 'BUVoucherListNotPlanned',
  BUVoucherListReceipExpense: 'BUVoucherListReceipExpense',
  BUVoucherListRealExpense: 'BUVoucherListRealExpense',
  BUVoucherListOther: 'BUVoucherListOther',
  PayStatements: 'PayStatements',
  CancelPayStatements: 'CancelPayStatements',
  SaveOpeningAccount: 'SaveOpeningAccount',
  DeleteOpeningAccount: 'DeleteOpeningAccount',

  // Rút dự toán
  BUPlanWithdrawCash: 'BUPlanWithdrawCash',

  // Điều chỉnh kinh phí
  BUExpenseWithdrawAdjustment: 'BUExpenseWithdrawAdjustment',
  BURealExpenseAdjustment: 'BURealExpenseAdjustment',

  //Sinh các loại giấy rút
  GenerateBUPlanWithdrawTransferDetail: 'GenerateBUPlanWithdrawTransferDetail', // Giấy rút dự toán tiền mặt
  GenerateBUPlanWithdrawDepositDetail: 'GenerateBUPlanWithdrawDepositDetail', // Giấy rút dự toán tiền gửi
  GenerateCAReceiptWithdrawDetail: 'GenerateCAReceiptWithdrawDetail',
  //In chứng từ
  Print_C213_TT772017_ST: 'C213_TT772017_ST',

  //Hóa đơn
  CreateSaleVoucher: 'CreateSaleVoucher',
  ReleaseInvoice: 'ReleaseInvoice',
  CancelInvoice: 'CancelInvoice',
  SendInvoice: 'SendInvoice',
  SendNotify: 'SendNotify',
  CreateSaleVoucherMulti: 'CreateSaleVoucherMulti',
  CreateAdjustSaleInvoice: 'CreateAdjustSaleInvoice', // Lập hóa đơn điều chỉnh vqphong - 22.09.2022
  SaleInvoiceReplace: 'SaleInvoiceReplace', //Lập hóa đơn thay thế
  DownloadInvoice: 'DownloadInvoice', // Tải hóa đơn
  ConvertToPaperVoucher: 'ConvertToPaperVoucher', // Chuyển thành hóa đơn giấy
  GenerateInvoice: 'GenerateInvoice', //Lập hóa đơn
  PublishInvoiceMulti: 'PublishInvoiceMulti',
  PublishInvoice: 'PublishInvoice',
  PreviewReceipt: 'PreviewReceipt',
  PreviewTicket: 'PreviewTicket',

  // Nhập số dư
  AccountBalance: 'AccountBalance',
  // Đóng thuế
  PayTax: 'PayTax',

  //Lương
  SalaryAllocation: 'SalaryAllocation',
  SalaryTemplateManage: 'SalaryTemplateManage',
  // sinh chi tiền gửi
  GenerateDrawSalary: 'GenerateDrawSalary',
  GenerateDataFundSalary: 'GenerateDataFundSalary', // sinh hạch toán chi phí lương
  GenerateDataFundInsurance: 'GenerateDataFundInsurance', // sinh hạch toán chi phí bảo hiểm
  SysRole: 'SysRole',
  GenerateBaDeposit: 'GenerateBaDeposit', // sinh thu tiền gửi
  GenerateCAReceipt: 'GenerateCAReceipt', // sinh phiếu thu
  GenerateGLVoucher: 'GenerateGLVoucher', // sinh chứng từ nghiệp vụ khác
  GenerateReceiptSale: 'GenerateReceiptSale', // Sinh bán hàng thu tiền ngay
  GenerateInvoiceSale: 'GenerateInvoiceSale', // sinh bán hàng chưa thu tiền
  GenerateReceiptFixedAsset: 'GenerateReceiptFixedAsset', // Sinh thu tiền mặt bán TSCĐ
  GenerateInvoiceFixedAsset: 'GenerateInvoiceFixedAsset', // sinh hóa đơn bán hàng cố định
  GetElectronicTicket: 'GetElectronicTicket', // Lấy vé điện tử
  InvolveVoucher: 'InvolveVoucher', // Chứng từ liên quan

  BackupData: 'BackupData', // Sao lưu dữ liệu
  StorageData: 'StorageData', // Lưu trữ dữ liệu

  // Báo cáo mẫu trộn
  DownloadMergeReport: 'DownloadMergeReport', // Tải về báo cáo mẫu trộn

  // Ghi tăng CCDC
  SUIncrement: ' SUIncrement',

  // Đã lập hồ sơ
  CreateDvcVoucher: 'CreateDvcVoucher',

  // Đã lập hồ sơ
  RemoveDvcVoucher: 'RemoveDvcVoucher',
  //Chia sẻ công thức báo cáo
  ShareReportFormula: 'ShareReportFormula',
  //Chia sẻ tiếp công thức báo cáo được chia sẻ
  ReShareReportFormula: 'ReShareReportFormula',
  //Áp dụng công thức báo cáo được chia sẻ
  ApplyFormula: 'ApplyFormula',

  // Xử lý chênh lệch
  HandleDifference: 'HandleDifference',
  // Lưu trữ
  Store: 'Store',
  // Phục hồi Lưu trữ
  RestoreStore: 'RestoreStore',

  AddRow: 'AddRow',
  DeleteRow: 'DeleteRow',
  // Chuyển danh mục tài khoản
  AccountTransfer: 'AccountTransfer',
  // Chuyển danh mục nguồn
  BudgetSourceTransfer: 'BudgetSourceTransfer',
  // Chuyển danh mục khoản
  BudgetKindItemTransfer: 'BudgetKindItemTransfer',
  // Chuyển danh mục CTMT-DA
  ProjectTransfer: 'ProjectTransfer',
  // Sắp xếp lại chứng từ
  SortRefNo: 'SortRefNo',
  // Tính giá xuất kho
  CalclnInOutward: 'CalclnInOutward',
  CreateDataPrevYear: 'CreateDataPrevYear',
  ConversionOfAccountingSystem: 'ConversionOfAccountingSystem',
  ConvertDesktop: 'ConvertDesktop',
  ImportVoucher: 'ImportVoucher',
  Import: 'Import',
  UpdateCircular: 'UpdateCircular',
  LockVoucher: 'LockVoucher',
  DataMaintaince: 'DataMaintaince',
  SendAccountingData: 'SendAccountingData',
  PayIncomeTax: 'PayIncomeTax', // Nộp thuế TNCN
  UpdateIntoSalary: 'UpdateIntoSalary', // Cập nhật vào bảng lương
  ExportXML: 'ExportXML', // Xuất XML
  SendEmailReminder: 'SendEmailReminder', // Gửi email nhắc nợ bán hàng chưa thu tiền
  RewriteParagraph: 'RewriteParagraph', // Viết lại văn bản bằng ava
  SendEmailPaySalary: 'SendEmailPaySalary', // Gửi email trả lương đến toàn bộ nhân viên (NHANH3 17.05.2024)
  //Xem tính năng mới
  ViewNewFeature: 'ViewNewFeature',
  SearchInfoCompany: 'SearchInfoCompany', //Tra cứu thông tin doanh nghiệp
  GenerateBuTransferMoneyElectric: 'GenerateBuTransferMoneyElectric', // Sinh chứng từ rút dự toán chuyển khoản kho bạc từ MISA AVA (tiền điện)
  GenerateBuTransferMoneyWater: 'GenerateBuTransferMoneyWater', // Sinh chứng từ rút dự toán chuyển khoản kho bạc từ MISA AVA (tiền nước)
  GenerateBuTransferMoneyPhone: 'GenerateBuTransferMoneyPhone', // Sinh chứng từ rút dự toán chuyển khoản kho bạc từ MISA AVA (tiền điện thoại)
  GenerateBuSalary: 'GenerateBuSalary', // Sinh chứng từ rút dự toán chuyển khoản lương từ MISA AVA
  GenerateBuInsurance: 'GenerateBuInsurance', // Sinh chứng từ rút dự toán chuyển khoản thanh toán bảo hiểm từ MISA AVA
  GenerateBuPlanWithDraw: 'GenerateBuPlanWithDraw', // Sinh chứng từ rút dự toán chuyển khoản từ MISA AVA
  VoiceInputInterpretation: 'VoiceInputInterpretation', // Nhập liệu diễn giải bằng giọng nói
  EditSampleS11H: 'EditSampleS11H', // Sửa mẫu sổ S11-H Sổ quỹ tiền mặt
  EditSampleC23HD: 'EditSampleC23HD', // Sửa mẫu sổ C23HD Biên bản kiểm kê vật tư, công cụ, sản phẩm, hàng hóa
  EditSample01a: 'EditSample01a', // Sửa mẫu sổ Mẫu số 01a-SDKP/ĐVDT
  EditSample01b: 'EditSample01b', // Sửa mẫu sổ Mẫu số 01b-SDKP/ĐVDT
  EditSample02a: 'EditSample02a', // Sửa mẫu sổ Mẫu số 02a-SDKP/ĐVDT 
  EditSample02b: 'EditSample02b', // Sửa mẫu sổ Mẫu số 02b-SDKP/ĐVDT 
  CheckStatusCompany: 'CheckStatusCompany', // Kiểm tra tình trạng doanh nghiệp
  HandleVoucherDifferentFixedAssetWithQLTS: 'HandleVoucherDifferentFixedAssetWithQLTS', // Xử lý chứng từ hạch toán chênh lệch TSCĐ với phần mềm QLTS
  ViewUserInfo: 'ViewUserInfo', // Xem thông tin người dùng
  ViewGuideVoucherNewYear: 'ViewGuideVoucherNewYear', // Xem hướng dẫn nhập chứng từ năm mới
  DeleteVoucherRelationWhenDeleteVoucherRoot: 'DeleteVoucherRelationWhenDeleteVoucherRoot', // Xóa chứng từng có liên quan khi thực hiện xóa chứng từ gốc
  AddDescriptionOnC30HD: 'AddDescriptionOnC30HD', // Thêm diễn giải trên mẫu C30-HD Phiếu nhập kho
  AddDescriptionOnC30HDTwoParts: 'AddDescriptionOnC30HDTwoParts', // Thêm diễn giải trên mẫu C30-HD Phiếu nhập kho (2 liên)
  AddDescriptionOnC30HDHasTax: 'AddDescriptionOnC30HDHasTax', // Thêm diễn giải trên mẫu C30-HD Phiếu nhập kho (có thuế)
  ChangeCapitalPlanYear: 'ChangeCapitalPlanYear', // Thay đổi Năm kế hoạch vốn trên mẫu C2-05a/NS
  SelectedStatistic: 'SelectedStatistic', // Chọn mã thống kê
  ConnectBumas: 'ConnectBumas', // Kết nối MISA BUMAS 
  GetDictionaryFromBumas: 'GetDictionaryFromBumas', // Lấy danh mục từ Bumas
  GetBumasDecision: 'GetBumasDecision', // Lấy quyết định giao từ Bumas
  SendDataBumas: 'SendDataBumas', // Đẩy thông tin tình hình thực hiện dự toán sang Bumas
  ExportExcel: 'ExportExcel', // Xuất Excel
  ConnectASP: 'ConnectASP', // Kết nối chuyên gia
  ReportSetting: 'ReportSetting', // Tùy chọn in
  EditCoverS61: 'EditCoverS61', // Sửa bìa S61
  ConvertFromOthers: 'ConvertFromOthers', // Tải bộ chuyển đổi từ phần mềm khác
  CreateDvcMS09: 'CreateDvcMS09', // Lập mẫu 09
  Restore: 'Restore', // Lấy lại thiết lập mặc định
  CreateTaxReduction1012023QH15: 'CreateTaxReduction1012023QH15', // Lập phụ lục Giảm thuế GTGT theo Nghị quyết 101/2023/QH15
  ExportXmlTaxReduction1012023QH15: 'ExportXmlTaxReduction1012023QH15', // Xuất khẩu XML mẫu phục lục Giảm thuế GTGT theo Nghị quyết 101/2023/QH15
  AddTAEnterpriseIncomeTax: 'AddTAEnterpriseIncomeTax', // Thêm mới tờ khai thuế thu nhập doanh nghiệp mẫu 04/TNDN
  PayUnionInsurance: 'PayUnionInsurance', // Nộp bảo hiểm, công đoàn phí
  GenSaleVoucherFromInvoice: 'GenSaleVoucherFromInvoice', // Sinh chứng từ bán hàng từ hóa đơn
  ChangeTaxCalculationMethod: 'ChangeTaxCalculationMethod', // Thực hiện lại chọn tính thuế GTGT theo phương pháp trực tiếp
  CoverDesign: 'CoverDesign', // Thiết kế bìa sổ
  OnlyEmployeeOutside: 'OnlyEmployeeOutside',
  IncludeEmployeeOutside: 'IncludeEmployeeOutside',
  Print052KQTTTNCN: 'Print052KQTTTNCN',
  ExportXML04GTGT: 'ExportXML04GTGT',
  EmployeeOutside: 'EmployeeOutside',
  CreateVoucherWithTaxDirect: 'CreateVoucherWithTaxDirect',
};
